import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { UtilValidationHelper } from "@rr/shared-util";
import { ThemeLoader } from "../../models";
@Component({
  selector: "rr-ui-core-ellipsis-loader",
  imports: [],
  templateUrl: "./ui-core-ellipsis-loader.component.html",
  styleUrl: "./ui-core-ellipsis-loader.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCoreEllipsisLoaderComponent {
  themeLoader = input<ThemeLoader | null>(null);
  isValidLoader = computed(() => {
    if (this.themeLoader()) {
      const img = UtilValidationHelper.isValidImageUrl(this.themeLoader()?.logo ?? "");
      const primary = UtilValidationHelper.isValidColor(this.themeLoader()?.primary ?? "");
      const secondary = UtilValidationHelper.isValidColor(this.themeLoader()?.secondary ?? "");
      return img && primary && secondary;
    }
    return false;
  });
}
